export interface IResetUserRequest {
    email: string;
}
